import classNames from 'classnames'
import { Fragment, h, JSX } from 'preact'

import { Image, ImageProps } from '../image/image'
import {
    ProductVariantRow,
    ProductVariantRowProps,
} from '../product-variant-row/product-variant-row'

export interface ProductListItemProps {
    id: number
    image: ImageProps
    name: string
    description: string
    readMore?: { text: string }
    variants: ProductVariantRowProps[]
    total?: {
        label: string
        price: string
    }
}

export const ProductListItem = (props: ProductListItemProps): JSX.Element => {
    const { image, name, description, readMore, total } = props

    return (
        <div
            class={classNames(
                'product-list-item',
                props.variants.length > 1 && 'product-list-item--with-variants',
            )}
        >
            {image.srcset && (
                <Image modifier="image--fluid" class="product-list-item__image" {...image} />
            )}
            <div class="product-list-item__content">
                <div class="product-list-item__data">
                    <div class="product-list-item__label">{name}</div>
                    {description && (
                        <div className="product-list-item__description">{description}</div>
                    )}
                    {readMore && <div class="product-list-item__read-more">{readMore.text}</div>}
                </div>
                <div class="product-list-item__variants">
                    {props.variants.map((variant) => (
                        <ProductVariantRow key={variant.id} {...variant} />
                    ))}
                </div>
            </div>
            <div class="product-list-item__total">
                {total && (
                    <>
                        <div class="product-list-item__label">{total.label}</div>
                        <div class="product-list-item__value">{total.price}</div>
                    </>
                )}
            </div>
        </div>
    )
}
